import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './KeyboardShortcuts.css';

const SHORTCUTS = [
  { keys: ['Alt', 'O'], label: 'Overblik', action: 'navigate', path: '/' },
  { keys: ['Alt', 'A'], label: 'Alle ordrer', action: 'navigate', path: '/orders' },
  { keys: ['Alt', 'I'], label: 'Indsigt', action: 'navigate', path: '/insights' },
  { keys: ['Alt', 'D'], label: 'Administration', action: 'navigate', path: '/administration' },
  { keys: ['Alt', 'N'], label: 'Ny booking', action: 'navigate', path: '/book' },
  { keys: ['Alt', 'M'], label: 'Import bookinger', action: 'navigate', path: '/import' },
  { keys: ['Alt', 'C'], label: 'AI Assistent', action: 'toggle-chat' },
  { keys: ['Alt', 'S'], label: 'Fokus søgefelt', action: 'focus-search' },
  { keys: ['Alt', 'K'], label: 'Vis genvejstaster', action: 'toggle-shortcuts' },
  { keys: ['Escape'], label: 'Luk dialog', action: 'close' },
];

function KeyboardShortcuts({ onToggleChat }) {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleKeyDown = useCallback((e) => {
    // Alt + key shortcuts
    if (e.altKey) {
      switch (e.key.toLowerCase()) {
        case 'o': e.preventDefault(); navigate('/'); break;
        case 'a': e.preventDefault(); navigate('/orders'); break;
        case 'i': e.preventDefault(); navigate('/insights'); break;
        case 'd': e.preventDefault(); navigate('/administration'); break;
        case 'n': e.preventDefault(); navigate('/book'); break;
        case 'm': e.preventDefault(); navigate('/import'); break;
        case 'c': e.preventDefault(); if (onToggleChat) onToggleChat(); break;
        case 's': e.preventDefault(); {
          const searchInput = document.querySelector('.search-box input');
          if (searchInput) searchInput.focus();
        } break;
        case 'k': e.preventDefault(); setShowModal(prev => !prev); break;
        default: break;
      }
    }
    if (e.key === 'Escape') {
      setShowModal(false);
    }
  }, [navigate, onToggleChat]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <>
      <button
        className="shortcuts-fab"
        onClick={() => setShowModal(true)}
        title="Genvejstaster (Alt+K)"
      >
        <span className="shortcuts-icon">&#9000;</span>
      </button>

      {showModal && (
        <div className="shortcuts-overlay" onClick={() => setShowModal(false)}>
          <div className="shortcuts-modal" onClick={(e) => e.stopPropagation()}>
            <div className="shortcuts-header">
              <h2>Genvejstaster</h2>
              <button className="shortcuts-close" onClick={() => setShowModal(false)}>&#10005;</button>
            </div>
            <div className="shortcuts-list">
              {SHORTCUTS.map((s, i) => (
                <div key={i} className="shortcut-row">
                  <span className="shortcut-label">{s.label}</span>
                  <span className="shortcut-keys">
                    {s.keys.map((k, j) => (
                      <span key={j}>
                        <kbd>{k}</kbd>
                        {j < s.keys.length - 1 && <span className="key-plus">+</span>}
                      </span>
                    ))}
                  </span>
                </div>
              ))}
            </div>
            <div className="shortcuts-footer">
              Tryk <kbd>Alt</kbd>+<kbd>K</kbd> for at skjule
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default KeyboardShortcuts;
